// extracted by mini-css-extract-plugin
export default {"cusrepSubSec":"cx06H","nameNDesc":"CIWXQ","cusrepHeadings":"PnTWO","cusrepValues":"FE97k","cusrepSubHeadings":"VC_v6","cusrepIcon":"VgNRQ"};